import { createSlice } from "@reduxjs/toolkit";

export const selectedCrop = createSlice({
  name: "selectedCrop",
  initialState: {
    value: {
      status: false,
      data: [],
    },
  },
  reducers: {
    updateSelectedCrop: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
  },
});

export const { updateSelectedCrop } = selectedCrop.actions;

export default selectedCrop.reducer;
